<template>
  <div class="login-page">
    <v-row no-gutters>
      <!-- form -->
      <v-col cols="10" md="12" sm="12" class="mt-1 mx-auto">
        <!-- sign in with -->
        <!-- <v-col cols="12" md="12" sm="4" align="center">
          <v-btn class="ma-2" elevation="3" fab color="white" small>
            <v-icon color="info">mdi-google</v-icon>
          </v-btn>
          <v-btn class="ma-2" elevation="3" fab color="white" small>
            <v-icon color="info">mdi-facebook</v-icon>
          </v-btn>
          <v-btn class="ma-2" elevation="3" fab color="white" small>
            <v-icon color="info">mdi-linkedin</v-icon>
          </v-btn>
        </v-col> -->
        <!-- sign in with ends -->
        <v-card
            class="ma-6 pa-4 mx-auto"
            rounded
            elevation="3"
            raised
            color="rgb(23,36,48,0.8)"
            max-width="600"
        >
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="login"
          >
            <v-col cols="12" md="12" sm="12">
              <v-img
                  src="/img/fantasy_lineups_logo.png"
                  width="400"
                  class="mx-auto"
              />
            </v-col>

            <!-- //* username -->
            <div align="center">
              <v-col cols="12" md="12" align="center">
                <small class="body-1 green--text"
                >Use your Username to Login</small
                >
              </v-col>

              <v-col cols="12" md="8" sm="8">
                <v-text-field
                    class="input"
                    v-model="form.userName"
                    label="User Name*"
                    outlined
                    filled
                    required
                    background-color="white"
                    prepend-inner-icon="mdi-account-circle-outline"
                ></v-text-field>
              </v-col>
            </div>

            <!-- //* password -->
            <div align="center" class="mt-n5">
              <v-col cols="12" md="8" sm="8">
                <v-text-field
                    class="input"
                    v-model="form.password"
                    label="Password*"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    outlined
                    filled
                    required
                    background-color="white"
                    prepend-inner-icon="mdi-form-textbox-password"
                ></v-text-field>
              </v-col>
              <!-- ... -->

              <v-col cols="12" md="8" sm="8" class="mt-n5">
                <v-btn block color="#72c604" type="submit" class="mr-4">
                  <v-progress-circular
                      v-if="loading"
                      indeterminate
                      :width="5"
                      color="primary"
                  ></v-progress-circular>
                  Sign In
                </v-btn>
              </v-col>
            </div>
            <v-col cols="12" md="12" align="center">
              <small class="body-2 font-weight-bold white--text">
                Don't have account?
                <router-link :to="{ name: 'SignUpForm' }" color="blue">
                  Sign Up
                </router-link>
              </small>
            </v-col>

            <v-col cols="12" md="12" align="center" class="mt-n5">
              <router-link
                  style="text-decoration: none"
                  :to="{ name: 'RecoverPasswordWOtp' }"
                  color="blue darken-1"
              >
                Forgot password ?
              </router-link>
            </v-col>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <!-- message for prepaid users.. -->
    <div v-if="dialog" class="text-center">
      <v-dialog persistent v-model="dialog" width="450">
        <v-card>
          <v-card-title class="text-h5 overline red--text">
            Message !
          </v-card-title>

          <v-card-text class="body-1">
            Last Payment processing is canceled due to prepaid cards policies we
            are currently not accepting prepaid cards for subscription payments.
            please try again with other cards available.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="proceed"> I Understand</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- message for prepaid users ends.. -->

    <!--//* message for email verification.. -->
    <div v-if="verifyDialog" class="text-center">
      <v-dialog persistent v-model="verifyDialog" width="450">
        <v-card>
          <v-card-title class="text-h5 overline red--text">
            Message !
          </v-card-title>

          <v-card-text class="body-1">
            Please verify your email address to continue.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="verifyDialog = false">
              I Understand
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!--//* message for email verification ends.. -->
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'loginForm',
  title: 'Fantasy Lineups Login Page',
  data: () => ({
    valid: true,
    snackbar: false,
    text: '',
    timeout: 2000,
    loading: false,
    showPassword: false,
    email: localStorage.getItem('email'),
    dialog: false,
    verifyDialog: false,

    //   emailRules: [
    //     (v) => !!v || "E-mail is required",
    //     (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    //   ],
    // passwordRules: [
    //   (v) =>
    //     (v && /^[a-z0-9\-]+$/.test(v)) ||
    //     `Only lowercase letters, numbers or hyphens allowed`,
    //   (v) => v.length >= 6 || 'Min 6 characters',
    // ],
    checkbox: false,
    authService: null,
    form: {
      userName: '',
      password: '',
    },
  }),

  computed: {
    ...mapState('NbaModule', ['customerSession', 'portal']),
  },

  methods: {
    loginCheck() {
      if (!this.$store.state.NbaModule.user.success) {
        alert('Invalid Password/userName');
      } else if (
        localStorage.getItem('status') === 'active' ||
        localStorage.getItem('status') === 'trialing' ||
        localStorage.getItem('status') === 'incomplete'
      ) {
        this.$router.replace({ name: 'NbaLayout' });
      } else if (
        localStorage.getItem('status') === 'inactive' &&
        localStorage.getItem('paymentType') === 'clickbank'
      ) {
        window.location.href = `https://dfslineups.pay.clickbank.net/?cbitems=1&cbskin=18731&email=${this.email}`;
      } else if (localStorage.getItem('status') === 'inactive') {
        const notification = {
          type: 'info',
          message: 'Welcome! Please choose a subscription plan to access the optimizer.'
        };
        this.$store.dispatch('notification/add', notification, { root: true });
        this.$router.replace({ name: 'Pricing' });
      } else {
        let obj = {
          stripe_customer_id: localStorage.getItem('stripe_customer_id'),
          // price_id: process.env.VUE_APP_PLATINUM_WEEKLY_PRICE,
        };

        this.$store.dispatch('NbaModule/createPortal', obj).then(() => {
          let path = this.portal.data.url;
          console.log('portal', path);
          location.href = path;
        });
      }
    },

    login() {
      if (this.$refs.form.validate()) {

        this.$store
            .dispatch('NbaModule/userLogin', {
              userName: this.form.userName,
              password: this.form.password,
            })
            .then(() => {
              let user = this.$store.state.NbaModule.user;
              console.log(user);

              if (!user.success) {
                return;
              }

              // Check for prepaid cards
              if (user.data.funding === 'prepaid') {
                this.dialog = true;
                return;
              }

              // Check if user is on Free plan
              if (user.data.plantype === 'Free' || user.data.plantype === '') {
                // Check email verification status
                if (user.data.verifystatus === '0') {
                  this.verifyDialog = true;
                  const notification = {
                    type: 'info',
                    message: 'Please verify your email address to continue using Fantasy Lineups.'
                  };
                  this.$store.dispatch('notification/add', notification, { root: true });
                } else {
                  // Show notification and redirect to pricing page
                  const notification = {
                    type: 'info',
                    message: 'Welcome! Please choose a subscription plan to access the optimizer.'
                  };
                  this.$store.dispatch('notification/add', notification, { root: true });
                  this.$router.replace({name: 'Pricing'});
                }
              } else {
                this.$router.replace({name: 'NbaLayout'});
              }
            });
      }
    },
    proceed() {
      this.dialog = false;
      const notification = {
        type: 'info',
        message: 'Please use a non-prepaid card to complete your subscription.'
      };
      this.$store.dispatch('notification/add', notification, { root: true });
      this.loginCheck();
    },
  },
};
</script>

<style scoped>
.login-page {
  background-size: cover;
  background: rgba(0, 0, 0, 0.9) url('/img/login_form_bg.png') no-repeat center;
  min-height: 100vh;
}

.input >>> input {
  color: rgba(0, 0, 0, 0.87);
  margin-top: 0;
}
</style>
